/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import M from "materialize-css";
import "../Header/Header.css";
import styles from "./Header.module.css";
import { withRouter } from "react-router-dom";
import LN from "../Content/LN-logo.png";
import { Activity, currentRequestTimeStamp, CLIENT_BASE_URL } from "./../Constants";
import ClickOutSideContext from "../ClickOutSide/ClickOutSideContext";
import ClickOutSide from "../ClickOutSide";
import { Urls } from "./../../Urls";
import ReactGA from "react-ga";
import mixpanel from "mixpanel-browser";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import GlobeIcon from "../../Content/images/GlobeIcon";

const Header = (props) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  // const closeBtnRef = useRef(null);
  const history = useHistory();

  const REFERRAL_CODE = "ELSC"
  const LORRI_BENCHMARK_URL = `${CLIENT_BASE_URL}signup/?code=${REFERRAL_CODE}`;

  useEffect(() => {
    let elems = document.querySelectorAll(".sidenav");
    M.Sidenav.init(elems, {
      edge: "left",
      inDuration: 250,
      outDuration: 250,
      preventScrolling: true,
      onCloseStart: () => {
        setIsNavbarOpen(false);
      },
    });

    let elems2 = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(elems2, {});
    var ip = sessionStorage.getItem("ClientIP");
    if (ip) {
      mixpanel.identify(ip);
      mixpanel.people.set({
        ClientIP: ip,
        time: currentRequestTimeStamp(),
      });
    }
  }, []);

  const trackActivity = (screen, module, userActivity, category, action, mixpanelLog) => {
    Activity([
      {
        screen: screen,
        module: module,
        user_activity: userActivity,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    ReactGA.event({
      category: category,
      action: action,
    });
    if (mixpanelLog) {
      mixpanel.track(mixpanelLog.eventName, {
        ApplicationName: `${Urls.mixpanelappname}`,
        ScreenName: "home",
        ModuleName: "landing_page",
        ...mixpanelLog.properties
      });
    }
  };

  const handleLogoClick = () => {
    history.push("/");
    trackActivity(
      "Header", "LogisticsNow Logo", "LogisticsNow Logo Button Clicked",
      "Header", "LogisticsNow Logo Button Clicked",
      { eventName: "User has clicked LogisticsNow Logo on header", properties: { ActivityLog: 'userClickedLogisticsNowLogo' } }
    );
  };

  return (
    <div className={styles.headerContainer}>
      {/* Top Header */}
      <div className={`${styles.topHeader}`}>
        <div className={styles.topHeaderContent}>
          <div className={styles.contactInfo}>
            <span className={styles.mailLink} onClick={() => window.location.href = "mailto:lorri@logisticsnow.in"}>
              <i className={`material-icons ${styles.icon}`}>email</i>
              lorri@logisticsnow.in
            </span>
            <span className={styles.phoneLink} onClick={() => window.location.href = "tel:9867773508"}>
              <i className={`material-icons ${styles.icon}`}>call</i>
              +91-9867773508
            </span>
          </div>

          <div className={styles.scheduleContainer}>
            <a
              href={window.location.pathname === "/" ? "#schedule-form" : "/#schedule-form"}
              className={styles.scheduleButton}
              onClick={() => trackActivity(
                "Home", "Schedule Demo Button", "Schedule Demo Button Clicked",
                "Home", "userClickedScheduleDemoButton",
                { eventName: "User has clicked on Schedule Demo button", properties: { ActivityLog: 'userClickedScheduleDemoButton' } }
              )}
            >
              SCHEDULE MEETING/ DEMO NOW
            </a>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className={styles.navWrapper}>
        <div className={styles.logoContainer} onClick={handleLogoClick}>
          <img src={LN} alt="LogisticsNow" className={styles.logoImage} />
        </div>

        {/* Desktop Links */}
        <ul className={`${styles.navLinks} hide-on-med-and-down`}>
          <div>
            <li className={styles.navItem}>
              <a href={`${Urls.LNBaseUrl}/about-us.aspx`} target="_blank" rel="noopener noreferrer" className={styles.navLink}>
                ABOUT US
              </a>
            </li>
            <li className={styles.navItem}>
              <a href={Urls.ClientBaseUrl} target="_blank" rel="noopener noreferrer" className={styles.navLink}>
                MANUFACTURER LOGIN
              </a>
            </li>
            <li className={styles.navItem}>
              <a href={Urls.TPMPBaseUrl} target="_blank" rel="noopener noreferrer" className={styles.navLink}>
                TRANSPORTER / LSP LOGIN
              </a>
            </li>
          </div>
          <li className={styles.navItem}>
            <a
              href={LORRI_BENCHMARK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`tooltipped ${styles.navLink} ${styles.benchmarkBtn}`}
              data-position="bottom"
              data-tooltip="Sign up now to experience LoRRI benchmark."
              onClick={() => trackActivity(
                "Header", "LoRRI Benchmark Button", "LoRRI Benchmark Button Clicked",
                "Header", "userClickedLoRRIBenchmarkButton",
                { eventName: "User has clicked LoRRI Benchmark button", properties: { ActivityLog: "userClickedLoRRIBenchmarkButton" } }
              )}
            >
              LoRRI Benchmark
              {/* <span className={styles.liveDot}></span> */}
            </a>
          </li>
        </ul>

        {/* Mobile Menu Trigger */}
        <a href="#!" data-target="mobile-menu" className={`sidenav-trigger ${styles.sidenavTrigger}`} onClick={() => setIsNavbarOpen(true)}>
          <i className="material-icons">menu</i>
        </a>
      </nav>

      {/* Mobile Sidebar */}
      <ul className="sidenav grey lighten-5" id="mobile-menu">
        <li>
          <a onClick={() => history.push("/")} className="btn sidenav-close" style={{ backgroundColor: "#393185", color: "white" }}>
            <b>HOME</b>
          </a>
        </li>
        <li>
          <a href={`${Urls.LNBaseUrl}/about-us.aspx`} target="_blank" rel="noopener noreferrer" className="btn sidenav-close" style={{ backgroundColor: "#393185", color: "white" }}>
            <b>ABOUT US</b>
          </a>
        </li>
        <li>
          <a
            href={LORRI_BENCHMARK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn sidenav-close"
            style={{
              backgroundColor: "#393185",
              color: "white",
              boxShadow: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 15px",
              borderRadius: "8px",
              height: "44px"
            }}
            onClick={() => trackActivity(
              "Header", "LoRRI Benchmark Button", "LoRRI Benchmark Button Clicked",
              "Header", "userClickedLoRRIBenchmarkButton",
              { eventName: "User has clicked LoRRI Benchmark button", properties: { ActivityLog: "userClickedLoRRIBenchmarkButton" } }
            )}
          >
            <b style={{ textTransform: "uppercase", display: "flex", alignItems: "center", gap: "8px", fontSize: "13px" }}>
              LORRI BENCHMARK
              <span style={{ backgroundColor: "#5cb85c", color: "white", fontSize: "10px", padding: "2px 8px", borderRadius: "10px", fontWeight: "800" }}>NEW</span>
            </b>
          </a>
        </li>
        <li>
          <a href={Urls.ClientBaseUrl} target="_blank" rel="noopener noreferrer" className="waves-effect btn-small">
            <b>MANUFACTURER LOGIN</b>
          </a>
        </li>
        <li>
          <a href={Urls.TPMPBaseUrl} target="_blank" rel="noopener noreferrer" className="waves-effect btn-small">
            <b>TRANSPORTER / LSP LOGIN</b>
          </a>
        </li>
        {/* Missing Item 1: What is LoRRI? */}
        <li>
          <a
            id="user_button"
            onClick={() => setShowNotifications(!showNotifications)}
            className="btn sidenav-close"
            style={{ backgroundColor: "#393185", color: "white" }}
          >
            <b>What is LoRRI?</b>
          </a>
        </li>
        {/* Missing Item 2: Global Grid */}
        <li>
          <a
            id="user_button"
            onClick={() => {
              history.push("/grid");
            }}
            className={`btn sidenav-close ${styles.sidebarGridBtn}`}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }} // Inline specific to flex centering
          >
            <GlobeIcon color="white" />
            <b style={{ lineHeight: 2, whiteSpace: "nowrap", marginLeft: "5px" }}>
              Global Smart Logistics Grid
            </b>
          </a>
        </li>
        {/* Close Button */}
        {/* <li>
          <a
            id="close-button"
            className="sidenav-close right" // Changed float-right to right (materialize helper) or CSS class
            ref={closeBtnRef}
          >
            <i
              className="material-icons close-icon"
              style={{ fontSize: "2rem", color: "black" }} // adjusted size/color visibility
            >
              close
            </i>
          </a>
        </li> */}
      </ul>

      {/* What is LoRRI Notification Popup */}
      {showNotifications && (
        <ClickOutSideContext.Provider
          value={{
            onClickOutSide: () => {
              setShowNotifications(false);
            },
          }}
        >
          <ClickOutSide className={styles.notificationPopup}>
            <div style={{ margin: "2%" }}>
              <div>
                <span style={{ color: "white", fontSize: "15px" }}>
                  <span style={{ fontSize: "25px" }}>LoRRI</span> is the trusted
                  logistics intelligence platform which enables companies and
                  transporters to drive savings, find their best fit partners
                  while leveraging actionable insights to enable reach and
                  reduce risk. LoRRI is created by{" "}
                  <a
                    href={Urls.LNBaseUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "white", textDecoration: "underline" }}
                  >
                    LogisticsNow
                  </a>{" "}
                  a pioneer in applying collective intelligence and
                  crowdsourcing to solve for logistics efficiency at scale.
                </span>
              </div>
            </div>
          </ClickOutSide>
        </ClickOutSideContext.Provider>
      )}
    </div>
  );
};

export default withRouter(Header);
